// extracted by mini-css-extract-plugin
export var displayNone = "_u3-6";
export var imgContainer = "_u3-2";
export var overflowHidden = "_u3-3";
export var productInfoCardButtonContainer = "_u3-5";
export var productTitleText = "_u3-4";
export var rightArrow = "_u3-1";
export var rightArrowContainer = "_u3-0";